export default {
    label: 'Payment method',
    methods: [
        'Credit/Debit Card',
        'Installment payments',
        'PromptPay'
    ],
    pay: 'Pay Now',
    invoice: 'Invoice',
    receipt: 'Receipt',
    total: 'Net Amount'
}
